import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Platform} from '@angular/cdk/platform';
import {OutputDialogData} from '../../models/dialog-models';

@Component({
    selector: 'app-filename-dialog',
    templateUrl: './filename-dialog.component.html',
    styleUrls: ['./filename-dialog.component.scss']
})
export class FileNameDialogComponent implements OnInit {
    protected extension = '';
    protected name = '';
    private currentOutputDialogData: OutputDialogData<string> = {
        doSave: false,
        value: ''
    };

    constructor(public dialogRef: MatDialogRef<FileNameDialogComponent>,
                @Inject(MAT_DIALOG_DATA) public data: any,
                public platform: Platform) {
        const d = this.data.split('.');
        this.extension = d[d.length - 1];

        this.name = this.data.substring(0, this.data.length - this.extension.length - 1);
    }

    ngOnInit(): void {
    }

    closeDialog(isYes: boolean): void {
        this.currentOutputDialogData.doSave = isYes;
        this.currentOutputDialogData.value = this.name + '.' + this.extension;
        this.dialogRef.close(this.currentOutputDialogData);
    }

    enterPressed($event: KeyboardEvent): void {
        if ($event.key === 'Enter') {
            this.closeDialog(true);
        }
    }
}
